import { Flex } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import type { AddBudgetProps } from '@/components/AddBudget/AddBudget.types'
import { BudgetFormAdd } from '@/components/BudgetFormAdd/BudgetFormAdd'
import { BudgetFormModal } from '@/components/BudgetFormModal/BudgetFormModal'
import { Button } from '@/components/Button/Button'

export function AddBudget({ currentBudget }: AddBudgetProps) {
  const [opened, { close, open }] = useDisclosure(false)

  return (
    <>
      <Flex justify="center">
        <Button
          onClick={open}
          w={{
            base: 'auto',
            lg: '100%',
          }}
        >
          Add a new budget category
        </Button>
      </Flex>

      <BudgetFormModal onClose={close} opened={opened}>
        <BudgetFormAdd currentBudget={currentBudget} onClose={close} />
      </BudgetFormModal>
    </>
  )
}
